import { render } from "./HiVaultFileDropMultiple.vue?vue&type=template&id=48dc085e&scoped=true"
import script from "./HiVaultFileDropMultiple.vue?vue&type=script&lang=js"
export * from "./HiVaultFileDropMultiple.vue?vue&type=script&lang=js"

import "./HiVaultFileDropMultiple.vue?vue&type=style&index=0&id=48dc085e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dc085e"]])

export default __exports__